import React, { Suspense, useCallback, useEffect, useState } from "react";
import cx from "classnames";
import { Switch, Redirect } from "react-router-dom";
import ProtectedRoute from "router/ProtectedRouteAdmin";
import { useSelector, useDispatch } from "react-redux";

// actions

// creates a beautiful scrollbar
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";

// actions creators
import { setIsMinimized } from "redux/ducks/config.js";
import { SnackbarStyled } from "./styles";
import { getCompaniesV2 } from "redux/actions/companies/companiesAction_V2";
import { getTagsV2 } from "redux/actions/tags/getTagsAction";
import { getTanks } from "redux/actions/tanks/tanksAction";
import { getBrandNamesV2, getBrandSalesV2, getBrandsV2 } from "redux/actions/brands/brandsAction_V2";
import { getUnitsV2 } from "redux/actions/unitsSection/unitsAction";

import vImage from "assets/img/crm_image.jpg";
import { getConditions } from "redux/actions/conditionsCatalog/conditionsCatalog";
import { closeSession } from "redux/actions/login/loginActions";
import { useSearch } from "hooks/useSearch";
import { animations } from "helpers/animations";
import { handleOpenAmazonConnect } from "redux/actions/customers/customersAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useForm } from "hooks/useForm";
import { _PROJECT } from "services/api";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { getBrandsMeters } from "redux/actions/buildings/brands/brandsMetersActions";
import { getSettlementProducts } from "redux/actions/routesStatus/routesStatusAction";
import { PrintingSnackbar } from "./PrintingSnackbar";
import ErrorBoundary from "error/ErrorBoundary";
import { orderArrayV2 } from "helpers/orderArray";
import { IS_CRM } from "utils/variables";
import { ORDERS_SEARCH_PARAMS } from "../../helpers/agentList";

export default function Dashboard(props) {
  const useStyles = makeStyles(styles);

  const { buildCompLoadings } = useSearch();
  const { location } = useHistory();
  const dispatch = useDispatch();
  const { ...rest } = props;
  // global states
  const { colorBg, colorSidebar, isMinimized } = useSelector(
    (state) => state.config,
  );

  const { user, token } = useSelector((state) => state.login);
  const rules = useSelector((state) => state.login.rules);
  const { loadInfo } = useSelector((state) => state.unitsReducer);
  const { printQueue, printedQueue } = useSelector(({ printers }) => printers);
  // states and functions
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const image = require("assets/img/sidebar-2.jpg");
  const logo = require("assets/icons/svg/ICONOS-32PX-FASE-2b.1-GENERIC-01.svg");
  // styles
  const { isOpen, message, color, position, snackbars } = useSelector(
    ({ search }) => search,
  );
  const { clearSnackbar, removeSnackbar } = useSearch();

  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    " gn4-main-panel " +
    cx({
      [classes.mainPanelSidebarMini]: isMinimized,
      // [classes.mainPanelWithPerfectScrollbar]:
      //   navigator.platform.indexOf("Win") > -1,
    });
  // ref for main panel div
  const mainPanel = React.createRef();
  // effect instead of componentDidMount, componentDidUpdate and componentWillUnmount
  React.useEffect(() => {
    window.addEventListener("resize", resizeFunction);
    return function cleanup() {
      window.removeEventListener("resize", resizeFunction);
    };
  });
  // functions for changeing the states from components

  const handleLogout = () => {
    localStorage.removeItem("isAvailable");
    localStorage.removeItem("contact-global");
    localStorage.removeItem("isOffline");
    localStorage.removeItem("eta_token");
    localStorage.removeItem(ORDERS_SEARCH_PARAMS);
    dispatch(closeSession());
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };
  const getActiveRoute = (routes) => {
    let activeRoute = "";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i]?.noTitle
            ? ""
            : routes[i]?.title
            ? routes[i].title
            : routes[i].name;
        }
        if (window.location.href.indexOf(routes[i].sublayout) !== -1) {
          return routes[i]?.noTitle
            ? ""
            : routes[i]?.title
            ? routes[i].title
            : routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getCredentials = (routes) => {
    const newRoutes = routes
      .filter((route) => {
        if (!route.inSidebar) {
          return false;
        }
        if (!route.isProtected) {
          return true;
        }
        if (rules && rules.includes(route.rule)) {
          return true;
        }
        return false;
      })
      .map((route) => {
        if (!route.views) {
          return route;
        } else {
          return {
            ...route,
            views: route.views.filter((view) => {
              if (!view.inSidebar) {
                return false;
              }
              if (!view.isProtected) {
                return true;
              }
              if (rules && rules.includes(view.rule)) {
                return true;
              }
              return false;
            }),
          };
        }
      })
      .filter((route) => {
        if (!route.views) {
          return true;
        }
        if (route.views.length === 0) {
          return false;
        }
        return true;
      });
    return newRoutes;
  };

  const getRoutes = (routes) => {
    return routes.map((prop) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <ProtectedRoute
            path={prop.layout + prop.path}
            isProtected={prop.isProtected}
            credential={prop.rule}
            component={prop.component}
            restoreKey={prop?.restoreKey}
            reducer={prop?.reducer}
            key={prop.path}
          />
        );
      } else {
        return null;
      }
    });
  };

  const sidebarMinimize = () => {
    dispatch(setIsMinimized(!isMinimized));
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  const runAll = useCallback(() => {
    if (loadInfo) {
      dispatch(getCompaniesV2(token));
      dispatch(getTagsV2(token));
      dispatch(getBrandsV2());
      dispatch(getTanks(token));
      dispatch(getBrandNamesV2(token));
      dispatch(getBrandSalesV2(token));
      dispatch(getUnitsV2(token));
      dispatch(getConditions());
      dispatch(getBrandsMeters());
      dispatch(getSettlementProducts());
    }
  }, [loadInfo]);

  const { inputValues, handleInputOnChange } = useForm({
    search: "",
  });
  const { search } = inputValues;
  useEffect(() => {
    runAll();
  }, []);

  useEffect(() => {
    buildCompLoadings([
      "loadingCustomers",
      "loadingTaxis",
      // 'loadingOrders',
      "loadingSurveys",
      "loadingSurvey",
      "loadingSurveysDownload",
    ]);
    localStorage.removeItem("contact-global");
  }, []);
  const handleCloseConnect = () => {
    rules.includes("CUSTOMER-CONNECT") &&
      !location.pathname.includes("unidades_menu") &&
      dispatch(handleOpenAmazonConnect(false));
  };

  const [filterRoutes, setFilterRoutes] = useState(routes);

  useEffect(() => {
    if (search.length > 0 && routes.length > 0) {
      const nRoutes = routes
        .filter((r) => r.name.toLowerCase().includes(search.toLowerCase()))
        .map((route) => {
          return {
            ...route,
            views: route?.views ? orderArrayV2(route.views, "name") : null,
          };
        });
      setFilterRoutes(nRoutes);
    } else {
      setFilterRoutes(
        routes.map((route) => {
          return {
            ...route,
            views: route?.views ? orderArrayV2(route.views, "name") : null,
          };
        }),
      );
    }
  }, [search, routes]);

  return (
    <div
      className={`${classes.wrapper} ${animations.fadeIn}`}
      style={{
        backgroundColor: IS_CRM ? "#dddddd" : "",
        animationDelay: ".5s",
      }}
    >
      <Sidebar
        routes={getCredentials(filterRoutes)}
        logoText={!IS_CRM ? _PROJECT : "CRM"}
        logo={!IS_CRM ? logo : ""}
        image={!IS_CRM ? image : vImage}
        handleDrawerToggle={handleDrawerToggle}
        handleLogout={handleLogout}
        open={mobileOpen}
        username={user}
        color={colorBg}
        bgColor={colorSidebar}
        miniActive={isMinimized}
        onChange={handleInputOnChange}
        search={search}
        {...rest}
      />
      <div className={mainPanelClasses} ref={mainPanel}>
        <AdminNavbar
          sidebarMinimize={sidebarMinimize.bind(this)}
          miniActive={isMinimized}
          brandText={getActiveRoute(filterRoutes)}
          handleDrawerToggle={handleDrawerToggle}
          // timeCounter={counter}
          {...rest}
        />
        {getRoute() ? (
          <div
            className={`${classes.content} gn4-content ${animations.fadeIn}`}
            onClick={handleCloseConnect}
            style={{
              marginTop: 52,
            }}
          >
            <Suspense fallback={<LoadingComponent />}>
              <div className={classes.container}>
                <ErrorBoundary>
                  <Switch>
                    {getRoutes(filterRoutes)}
                    <Redirect from="/admin" to="/admin/dashboard" />
                  </Switch>
                </ErrorBoundary>
              </div>
            </Suspense>
          </div>
        ) : (
          <div className={classes.map}>
            <ErrorBoundary>
              <Switch>
                {getRoutes(filterRoutes)}
                <Redirect from="/admin" to="/admin/dashboard" />
              </Switch>
            </ErrorBoundary>
          </div>
        )}
        {getRoute() ? (
          <ErrorBoundary>
            <Footer fluid />
          </ErrorBoundary>
        ) : null}
        <SnackbarStyled
          place={position}
          color={color}
          message={message}
          open={isOpen}
          closeNotification={clearSnackbar}
          close
          snackbars={snackbars}
          onRemove={removeSnackbar}
        />
        {(printQueue.length > 0 || printedQueue.length > 0) && (
          <PrintingSnackbar />
        )}
      </div>
    </div>
  );
}
